import {AnalyticDestination} from 'src/lib/EventStream/EventStream.types'

/**
 * Define where analytic event should go by default.
 * Can be overridden by setting the destinations property on the analytic event.
 */
const DefaultAnalyticDestinations: AnalyticDestination[] = ['amplitude', 'braze']

export {DefaultAnalyticDestinations}
